<template>
  <div class="row justify-center">
    <div class="sm:col-auto flex flex-col sm:block pt-2">
      <router-link
        :to="{ name: 'cartsPath' }"
        class="btn btn-success py-3 px-9 rounded-pill"
      >
        {{ t('enter_to_cart') }}
      </router-link>
    </div>
    <div class="sm:col-auto flex flex-col sm:block pt-2">
      <button
        type="button"
        data-dismiss="modal"
        class="btn btn-warning py-3 px-9 rounded-pill"
        @click="closeModal"
      >
        {{ t('continue_shopping') }}
      </button>
    </div>
    <div
      v-if="false"
      class="sm:col-auto flex flex-col sm:block pt-2"
    >
      <button
        type="button"
        data-dismiss="modal"
        class="btn btn-danger py-3 px-9 rounded-pill"
        @click="editMix"
      >
        {{ t('edit_mix') }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

import { useModalStore } from '@/stores/ModalStore'

const { t } = useI18n()

const { closeModal } = useModalStore()
</script>

<i18n>
  {
    "cs": {
    "continue_shopping": "Pokračovat v nákupu",
    "edit_mix": "Upravit mix",
    "enter_to_cart": "Vstoupit do košíku"
},
    "sk": {
    "continue_shopping": "Pokračovať v nákupe",
    "edit_mix": "Upraviť mix",
    "enter_to_cart": "Vstúpiť do košíka"
},
    "pl": {
    "continue_shopping": "Kontunuuj zamówienie",
    "edit_mix": "Edytuj mieszankę",
    "enter_to_cart": "Idź do koszyka"
},
    "hu": {
    "continue_shopping": "Folytatni a vásárlást",
    "edit_mix": "Mix módosítása",
    "enter_to_cart": "Tovább a kosárhoz"
},
    "de": {
    "continue_shopping": "Weiter einkaufen",
    "edit_mix": "Mix bearbeiten",
    "enter_to_cart": "Zum Warenkorb"
},
    "at": {
    "continue_shopping": "Weiter einkaufen",
    "edit_mix": "Mix bearbeiten",
    "enter_to_cart": "Zum Warenkorb"
},
    "ro": {
    "continue_shopping": "Continuă cumpărăturile",
    "edit_mix": "Modificare mix",
    "enter_to_cart": "Mai departe la coș"
},
    "fr": {
    "continue_shopping": "Continuer à acheter",
    "edit_mix": "Modifier le mix",
    "enter_to_cart": "Entrez dans le panier"
}
  }
</i18n>
